import { type FormEvent, useState } from "react";
import { cardBorderClassName } from "../lib/cardStyles";

export type TeamMemberFormValues = {
  name: string;
  role: string;
  phone: string;
  email: string;
};

type TeamMemberFormProps = {
  onSubmit: (values: TeamMemberFormValues) => void;
  onCancel?: () => void;
  submitLabel?: string;
  showCancel?: boolean;
  className?: string;
};

const inputClass =
  "w-full px-3 py-2 rounded-lg bg-black/40 border border-purple-500/30 text-white text-sm focus:outline-none focus:border-purple-500";

export default function TeamMemberForm({
  onSubmit,
  onCancel,
  submitLabel = "Save",
  showCancel = true,
  className = "",
}: TeamMemberFormProps) {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const reset = () => {
    setName("");
    setRole("");
    setPhone("");
    setEmail("");
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;

    onSubmit({
      name: trimmedName,
      role: role.trim(),
      phone: phone.trim(),
      email: email.trim(),
    });
    reset();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`p-5 rounded-xl ${cardBorderClassName} ${className}`}
      style={{ background: "rgba(28, 28, 37, 0.8)" }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label
            className="block text-xs text-gray-400 mb-1"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Name *
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Jane Smith"
            className={inputClass}
          />
        </div>
        <div>
          <label
            className="block text-xs text-gray-400 mb-1"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Role
          </label>
          <input
            type="text"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            placeholder="Office Manager"
            className={inputClass}
          />
        </div>
        <div>
          <label
            className="block text-xs text-gray-400 mb-1"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Phone (E.164)
          </label>
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+19495551212"
            className={inputClass}
          />
        </div>
        <div>
          <label
            className="block text-xs text-gray-400 mb-1"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="jane@example.com"
            className={inputClass}
          />
        </div>
      </div>
      <div className="flex gap-2">
        <button
          type="submit"
          className="px-4 py-2 rounded-lg text-sm font-semibold text-white cursor-pointer"
          style={{
            background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          {submitLabel}
        </button>
        {showCancel && onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm text-gray-300 cursor-pointer"
            style={{
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(138, 43, 226, 0.2)",
              fontFamily: "'Space Grotesk', sans-serif",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}
